import { IProtectedRouteMap } from "libs/auth/types/routes";

export const AUTH_ONLY_ROUTES: IProtectedRouteMap = {
  "/customer": {
    redirectUrl: undefined,
    match: "STARTS_WITH",
  },
  "/reactivate": {
    redirectUrl: undefined,
    match: "STARTS_WITH",
  },
  "/routing/action/edit-delivery": {
    redirectUrl: undefined,
    match: "STARTS_WITH",
  },
  "/routing/action/edit-extras": {
    redirectUrl: undefined,
    match: "STARTS_WITH",
  },
  "/routing/action/edit-recipe": {
    redirectUrl: undefined,
    match: "STARTS_WITH",
  },
};

export const GUEST_ONLY_ROUTES: IProtectedRouteMap = {
  "/": {
    redirectUrl: undefined,
    match: "EXACT",
  },
  "/forms/fresh-new-user": {
    redirectUrl: "/forms/fresh-existing-user",
    match: "STARTS_WITH",
  },
  "/sign-up/fresh": {
    redirectUrl: "/forms/fresh-existing-user",
    match: "STARTS_WITH",
  },
};

export const PRODUCTION_URLS = [
  "https://www.katkin.com",
  "https://katkin.com",
] as const;

export const JWT_HASH_ALGORITHM = "RS256";
